<template>
  <section>
    <div v-if="!order.can_select_pre_booking_professionals">
      <div class="mt-3" v-if="order.status === 0 && order.declined_order_data && order.selected_professional_id != 0">
        <div class="-bg-warning-soft border border-warning rounded-all d-flex justify-content-start align-content-top p-2 mb-3">
          <div>
            <i class="fal fa-exclamation-circle text-danger"></i>
          </div>
          <div class="text-left pl-2 text-small">
            {{ $t('message.my_reservations.declined_booking_remark') }}
          </div>
        </div>
        <button class="btn btn-outline-info btn-block" @click="confirmFindNewCleaner">
          {{ $t('message.button.find_new_provider') }}
        </button>
      </div>
    </div>
    <div v-else>
      <div class="mt-3" v-if="order.status === 0 && (order.pre_booking_professionals || order.declined_order_data)">
        <div class="text-left">
          <span class="text-info">BeNeat</span> {{ $t('message.booking.switch_professional.offer_pre_booking_professionals') }}
          <a href="" @click.prevent="openInfoModal"><i class="fal fa-exclamation-circle text-info"></i></a>
        </div>
        <div class="alert alert-info my-3 text-center p-2" role="alert">
          {{ $t('message.booking.switch_professional.select_pre_booking_professionals') }}
        </div>
        <div class="d-flex justify-content-start" v-if="order.pre_booking_professionals">
          <div class="flex-even" v-for="professional in order.pre_booking_professionals">
            <a href="" class="text-reset text-decoration-none" @click.prevent="openProfessionalDetailModal(professional.id)">
              <div class="position-relative" :style="`width: ${imgSize}px; margin: 0 auto;`">
                <img class="img-pre-booking-professional-first rounded-circle" 
                    :src="professional.full_picture" 
                    :width="imgSize">
                  <div class="position-absolute" style="right:0; bottom: 0;">
                    <i class="fas fa-circle -status-accepted" :class="{ 'text-small': (imgSize === 48) }"></i>
                  </div>
              </div>
              <div class="mt-2 text-small text-center">
                {{ professional.full_name | firstName }}
              </div>
            </a>
          </div>
        </div>
        <div class="bg-gray rounded p-3 text-center" v-else>
          <img src="/static/img/ic_hourglass.svg">
          <div class="text-small pt-2">
            {{ $t('message.booking.switch_professional.searching_pre_booking_professionals') }}
          </div>
          <div class="text-info text-small pt-2">
            {{ $t('message.booking.switch_professional.searching_pre_booking_professionals_remark') }}
          </div>
        </div>
      </div>
    </div>
    <!-- Professional detail modal -->
    <professional-detail-modal ref="profDetailModal" />
    <!-- Info modal -->
    <select-pre-booking-professional-info-modal ref="infoModal" />
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProfessionalDetailModal from './ProfessionalDetailModal'
  import SelectPreBookingProfessionalInfoModal from './SelectPreBookingProfessionalInfoModal'
  
  export default {
    props: {
      order: Object,
      imgSize: Number
    },
    components: {
      ProfessionalDetailModal,
      SelectPreBookingProfessionalInfoModal
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      confirmFindNewCleaner () {
        this.$swal({
          title: this.$i18n.t('message.declined_booking.find_new_cleaner_tile'),
          text: this.$i18n.t('message.declined_booking.find_new_cleaner_detail'),
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(async () => {
          // Find new cleaner
          const submitData = {
            order_id: this.order.id,
            user_id: this.user.id,
            validation: ''
          }
          await this.$store.dispatch('orderDetail/FIND_NEW_CLEANER', submitData)
          this.loadOrderDetail(this.order.id)
        })
      },
      openInfoModal () {
        this.$refs.infoModal.showModal(true)
      },
      openProfessionalDetailModal (profId) {
        const payload = {
          orderId: this.order.id,
          professionalId: profId
        }
        this.$refs.profDetailModal.showModal(payload)
      }
    }
  }
</script>

<style scoped>
.flex-even {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/order/components/PreBookingProfessionalSelectionSection.vue